'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookGlobalSettings = require('@narvar/nth-hook-global-settings');
var BlockEdd = require('./BlockEdd.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const BlockEddWithSettingsCheck = ({
  featureName
}) => {
  const {
    loading,
    error,
    globalSettings
  } = nthHookGlobalSettings.useGlobalSettingsX();
  if (loading || error) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
  const {
    internationalDateFormatting
  } = globalSettings;
  return /*#__PURE__*/React__default["default"].createElement(BlockEdd["default"], {
    featureName: featureName,
    internationalDateFormatting: internationalDateFormatting
  });
};
var index = nthHookGlobalSettings.withGlobalSettingsProvider(BlockEddWithSettingsCheck, {
  globalSettingsRequested: 'internationalDateFormatting'
});

exports["default"] = index;
